import {WP_API_URL} from "@/utils/constants";

export function getToken() {
    const cookies = document.cookie.split(';');

    let jwtToken = null;
    cookies.forEach(cookie => {
        const [name, value] = cookie.split('=');
        if (name.trim() === 'cbgToken') {
            jwtToken = value;
        }
    });

    return jwtToken;
}

export function setAccessToken(token, remember) {
    sessionStorage.removeItem('accessToken', token);
    localStorage.removeItem('accessToken', token);
    remember
        ?
        localStorage.setItem('accessToken', token)
        :
        sessionStorage.setItem('accessToken', token);
}

export function getAccessToken() {
    return sessionStorage.getItem('accessToken') || localStorage.getItem('accessToken');
}

export function removeAccessToken() {
    sessionStorage.removeItem('accessToken');
    localStorage.removeItem('accessToken');
}

export function setRefreshToken(token) {
    localStorage.setItem('refreshToken', token);
}

export function getRefreshToken() {
    return localStorage.getItem('refreshToken');
}

export function resizeImage(image) {
    const canvas = document.createElement('canvas');
    const maxWidth = 200;
    const maxHeight = 200;
    let width = image.width;
    let height = image.height;
    const ctx = canvas.getContext('2d');

    if (width > height) {
        if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
        }
    } else {
        if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
        }
    }

    canvas.width = width;
    canvas.height = height;

    ctx.drawImage(image, 0, 0, width, height);

    return canvas.toDataURL('image/webp');
}

export function fileToImage(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
            const img = new Image();
            img.onload = () => resolve(img);
            img.onerror = reject;
            img.src = reader.result;
        };

        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

export async function handleSuccess(action, payload) {
    try {
        const response = await fetch(WP_API_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action,
                ...payload
            })
        });

        // if (!response.ok) {
        //     throw new Error(`HTTP error! Status: ${response.status}`);
        // }

        const data = await response.json();
        handleResponse(data);

    } catch (error) {
        console.error('Response error:', error);
    }
}

export function handleResponse(response) {
    if (response.data.refresh_page && cbgAuthRefreshPage[0]) {
        window.location.reload();
    }
}
